import { IonRouterOutlet } from '@ionic/react';
import React, { memo } from 'react';

import GuardedRoute from '../../components/router/GuardedRoute';
import Devices from './wire/Devices';
import Overview from './wire/Overview';
import Rooms from './wire/Rooms';

const TabWire: React.FC = memo(() => {
    return (
        <IonRouterOutlet ionPage>
            <GuardedRoute
                exact
                path="/:jobId/installation/wire"
                component={Overview}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/wire/rooms/"
                component={Rooms}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/wire/rooms/:roomId"
                component={Rooms}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/wire/rooms/:roomId/devices"
                component={Devices}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/wire/rooms/:roomId/devices/:deviceId"
                component={Devices}
            />
        </IonRouterOutlet>
    );
});

export default TabWire;
